import React, { createContext, useContext, useEffect, useReducer, useCallback } from "react";
import axios from "axios";
import store from "../store/store";

const initialState = {
  user: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        user: {
          _id: action._id,
          user_email: action.user_email,
          level: action.level,
          company_name: action.company_name,
          manager_name: action.manager_name,
          manager_contact: action.manager_contact
        },
      };
    case "UPDATE_LEVEL":
      if (!state.user) return state;
      return {
        ...state,
        user: {
          ...state.user,
          level: action.level,
        },
      };
    case "LOGOUT":
      return {
        ...state,
        user: null,
      };
    default:
      return state;
  }
};

const UserStateContext = createContext(null);
const UserDispatchContext = createContext(null);

// 등급 갱신 주기 (5분)
const LEVEL_REFRESH_INTERVAL = 5 * 60 * 1000;

export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState, () => {
    const localData = localStorage.getItem('user');
    return localData ? JSON.parse(localData) : initialState
  });

  useEffect(() => {
    localStorage.setItem('user', JSON.stringify(state))
  }, [state])

  // 주기적으로 서버에서 등급 확인
  const refreshLevel = useCallback(async () => {
    if (!state.user || !state.user._id) return;
    try {
      const res = await axios.get(`/api/users/level/${state.user._id}`);
      if (res.data.level && res.data.level !== state.user.level) {
        dispatch({ type: "UPDATE_LEVEL", level: res.data.level });
        // 장바구니에 아이템이 있으면 비우기 (가격이 달라지므로)
        const cartState = store.getState().cartReducer;
        if (cartState && cartState.length > 0) {
          store.dispatch({ type: "CLEAR_CART" });
        }
      }
    } catch (err) {
      // 네트워크 오류 등은 무시 (다음 주기에 재시도)
    }
  }, [state.user]);

  useEffect(() => {
    if (!state.user) return;
    // 앱 로드 시 즉시 한번 확인
    refreshLevel();
    const interval = setInterval(refreshLevel, LEVEL_REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [state.user && state.user._id, refreshLevel]);

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
};

export const useUserState = () => {
  const state = useContext(UserStateContext);
  if (!state) throw new Error("Cannot find UserProvider");
  return state;
};

export const useUserDispatch = () => {
  const dispatch = useContext(UserDispatchContext);
  if (!dispatch) throw new Error("Cannot find UserProvider");
  return dispatch;
};
